






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Title extends Vue {
    @Prop({ default: '' }) private labelJP!: string;
    @Prop({ default: '' }) private labelEN!: string;

}
